export const SET_CMS_PAGINANAAM = "SET_CMS_PAGINANAAM";
